// Compute an end time from a "HH:MM" start and a number of hours.
// computeEndTime('11:00', 9) -> '20:00'
export const computeEndTime = (startTime, hours) => {
  if (!startTime || !hours) return null;
  const [h, m] = String(startTime).split(':').map((n) => parseInt(n, 10));
  if (Number.isNaN(h)) return null;
  const total = ((h * 60 + (m || 0) + Math.round(parseFloat(hours) * 60)) % (24 * 60) + 24 * 60) % (24 * 60);
  const eh = Math.floor(total / 60);
  const em = total % 60;
  return `${String(eh).padStart(2, '0')}:${String(em).padStart(2, '0')}`;
};
